<template>
  <myFormVue addTitle="Add New Podcast Episode" updateTitle="Update Podcast Episode" :submitLoading="submitLoading"
    accept=".mp4,.mkv, .mp3" :isUpdating="dataObj == null" :step="step_no" :step_count="3" @stepForward="stepForward"
    @stepBackward="stepBackward" @submit="submit" @onFileInit="initFile" @closeModal="$emit('closeModal')">
    <div class="modal_body_part split_step">

      <!-- Left panel: Tab 1 -->
      <div class="split_part_data" v-if="step_no == 2">
        <h1 class="title">Details</h1>
        <div class="data-form">
          <b-field label="Title (Required)">
            <b-input v-model="form.name" type="text" placeholder="Enter Name"></b-input>
          </b-field>
          <b-field label="Episode Number (Required)">
            <b-input v-model="form.episode_number" type="number" min="1" placeholder="Enter Episode Number"></b-input>
          </b-field>
          <b-field label="Description">
            <b-input v-model="form.description" type="textarea" placeholder="Enter Description"></b-input>
          </b-field>
          <br>
          <label class="label">Thumbnail Image</label>
          <p class="b-field-txt">
            Select or upload cover image that stands as cover image for the podcast. A good cover image stands out and
            draws viewers’ attention.
          </p>
          <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
            location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL"
            :uploadurl="$store.state.BASE_URL + 'upload'" name="main-image" :value="form.cover" @onFileSelected="(file) => {
              form.cover = file;
            }
              ">
            <div class="image-upload-widget">Choose Image</div>
          </upload-trigger><br>
          <label class="label">Lagging Image</label>
          <p class="b-field-txt">
            Select or upload cover image that stands as cover image for the podcast. A good cover image stands out and
            draws viewers’ attention.
          </p>
          <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
            location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL"
            :uploadurl="$store.state.BASE_URL + 'upload'" name="main-image" :value="form.lagging_image" @onFileSelected="(file) => {
              form.lagging_image = file;
            }
              ">
            <div class="image-upload-widget">Choose Image</div>
          </upload-trigger><br>
        </div>
        <h1 class="title">Visibility (Required)</h1>
        <div class="data-form">
          <div class="visibility-grp">
            <h1 class="visibility-grp-title">Save or Publish</h1>
            <p class="visibility-grp-sub">Make your music public, unlisted, or private</p>
            <div class="visibility-togglers">
              <div class="visibility-togglers-each">
                <h1>
                  <b-radio v-model="form.visibility" native-value="private" type="is-success" size="is-small">
                  </b-radio>
                  Private
                </h1>
                <p>Only you and people you choose can watch your video</p>
              </div>
              <div class="visibility-togglers-each">
                <h1>
                  <b-radio v-model="form.visibility" native-value="unlisted" type="is-success" size="is-small">
                  </b-radio>
                  Unlisted
                </h1>
                <p>Anyone with the music link can watch your music</p>
              </div>
              <div class="visibility-togglers-each">
                <h1>
                  <b-radio v-model="form.visibility" native-value="public" type="is-success" size="is-small">
                  </b-radio>
                  Public
                </h1>
                <p>Everyone can watch your video</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Left panel: Tab 1 -->
      <div class="split_part_data" v-if="step_no == 3">
        <b-field label="Podcast Duration" message="Double click to navigate the time"
          v-if="dataObj && dataObj.converting_status == 'cdn_upload_completed'">
          <widgetMediaTimeInput v-model="form.duration"
            :src="`${$store.state.ASSETS_VIDEO_BASE_URL}${dataObj.videoPath}`"></widgetMediaTimeInput>
        </b-field>

        <b-field label="Podcast Intro Starter Time" message="Double click to navigate the time"
          v-if="dataObj && dataObj.converting_status == 'cdn_upload_completed'">
          <widgetMediaTimeInput v-model="form.introStartTime"
            :src="`${$store.state.ASSETS_VIDEO_BASE_URL}${dataObj.videoPath}`"></widgetMediaTimeInput>
        </b-field>

        <b-field label="Podcast End Intro Time" message="Double click to navigate the time"
          v-if="dataObj && dataObj.converting_status == 'cdn_upload_completed'">
          <widgetMediaTimeInput v-model="form.introEndTime"
            :src="`${$store.state.ASSETS_VIDEO_BASE_URL}${dataObj.videoPath}`"></widgetMediaTimeInput>
        </b-field>

        <b-field label="Podcast End Time" message="Double click to navigate the time"
          v-if="dataObj && dataObj.converting_status == 'cdn_upload_completed'">
          <widgetMediaTimeInput v-model="form.movieEndTime"
            :src="`${$store.state.ASSETS_VIDEO_BASE_URL}${dataObj.videoPath}`"></widgetMediaTimeInput>
        </b-field>

      </div>

      <!-- Right panel -->
      <div class="split_part_view" v-if="step_no >= 2">
        <div class="data_cover">
          <img v-if="form.cover" :src="$store.state.ASSETS_BASE_URL + 'assets/uploaded/' + form.cover"
            alt="Cover Image">
          <b-skeleton v-else id="img-skeleton"></b-skeleton>
          <div class="media" @click="toggleMedia">
            <b-icon icon="play"></b-icon>
          </div>

          <div class="media-visibility-status" v-if="dataObj">
            <b-tag :type="visibilityClass">{{ form.visibility }}</b-tag>
          </div>

        </div>
        <h1 class="name" v-if="form.name">{{ form.name }}</h1>
        <h1 class="name" v-else>
          <b-skeleton width="80%"></b-skeleton>
        </h1>
        <p class="descr" v-if="form.description">{{ form.description }}</p>
        <div class="spaced-skeleton" v-else>
          <b-skeleton></b-skeleton>
          <b-skeleton width="85%"></b-skeleton>
          <b-skeleton width="75%"></b-skeleton>
        </div>
      </div>

    </div>


    <!-- ClapprPlayer -->
    <b-modal v-model="show_player" :width="800">
      <div style="height: 500px" v-if="dataObj">
        <ClapprPlayer :src="`${$store.state.ASSETS_VIDEO_BASE_URL}${dataObj.videoPath}`" type="hls">
        </ClapprPlayer>
      </div>
    </b-modal>

  </myFormVue>
</template>

<script>
import myFormVue from '../components/myForm.vue';
export default {
  components: { myFormVue },
  props: {
    dataObj: {
      type: Object,
      default: null
    },
    podcastId: {
      type: Number,
      default: null
    },
    nextEpisode: {
      type: Number,
      default: null
    },
  },
  data() {
    return {
      show_player: false,
      isPlaying: false,
      filteredTags: null,
      step_no: 1,
      submitLoading: false,
      form: {
        id: null,
        name: '',
        visibility: '',
        description: '',
        cover: null,
        introStartTime: '',
        introEndTime: '',
        movieEndTime: '',
        duration: '',
        mediaId: null
      }
    }
  },
  mounted() {
    let vm = this;
    if (vm.dataObj) {
      vm.step_no = 2
      vm.form = {
        id: vm.dataObj.id,
        name: vm.dataObj.title,
        description: vm.dataObj.description,
        visibility: vm.dataObj.visibility,
        cover: vm.dataObj.cover,
        lagging_image: vm.dataObj.lagging_image,
        introStartTime: vm.dataObj.intro_start_time,
        introEndTime: vm.dataObj.intro_end_time,
        movieEndTime: vm.dataObj.intro_end_time,
        duration: vm.dataObj.duration,
        episode_number: vm.dataObj.episode_number,
        mediaId: vm.dataObj.videoId
      }
    } else {
      vm.form = {
        id: null,
        name: '',
        visibility: '',
        description: '',
        cover: null,
        lagging_image: null,
        introStartTime: '',
        introEndTime: '',
        movieEndTime: '',
        duration: '',
        podcast_id: vm.podcastId,
        episode_number: '',
        mediaId: null
      }
    }
  },
  computed: {
    visibilityClass() {
      let vm = this;
      if (vm.form.visibility == 'private') {
        return 'is-warning'
      } else if (vm.form.visibility == 'unlisted') {
        return 'is-danger'
      } else {
        return 'is-success'
      }
    }
  },
  methods: {
    initFile(mediaId) {
      let vm = this;
      vm.form.mediaId = mediaId;
    },
    toggleMedia() {
      let vm = this;
      vm.show_player = !vm.show_player
    },
    getFilteredTags(text) {
      let vm = this;
      this.filteredTags = vm.playlist.filter((each) => {
        return each.name
          .toString()
          .toLowerCase()
          .indexOf(text.toLowerCase()) >= 0
      })
    },
    stepForward() {
      let vm = this;
      vm.uploadedSuccessfully = true;
      if (vm.step_no < 3) {
        vm.step_no++;
      }
    },
    stepBackward() {
      let vm = this;
      vm.uploadedSuccessfully = true;
      if (vm.step_no != 1) {
        vm.step_no--;
      }
    },
    submit() {
      let vm = this;
      if (vm.form.name && vm.form.visibility && vm.form.episode_number) {
        vm.submitLoading = true;
        if (vm.dataObj) {
          vm.form.id = vm.dataObj.id;
          vm.$store.dispatch('UPDATE_PODCASTS_EPISODES', vm.form)
            .then((res) => {
              vm.submitLoading = false;
              vm.$emit('closeModal');
              vm.$emit('refresh');
              vm.$notify({
                group: "status",
                type: "success",
                title: "SUCCESS!!!",
                text: 'Episode Updated Successfully',
              });
            })
            .catch((err) => {
              vm.submitLoading = false;
              console.log(err)
              vm.$notify({
                group: "status",
                type: "error",
                title: "OOPS!!!",
                text: 'Something went wrong',
              });
            })
        } else {
          vm.$store.dispatch('ADD_PODCASTS_EPISODES', vm.form)
            .then((res) => {
              vm.submitLoading = false;
              vm.$emit('closeModal');
              vm.$emit('refresh');
              vm.$notify({
                group: "status",
                type: "success",
                title: "SUCCESS!!!",
                text: 'Episode Added Successfully',
              });
            })
            .catch((err) => {
              vm.submitLoading = false;
              vm.$notify({
                group: "status",
                type: "error",
                title: "OOPS!!!",
                text: 'Something went wrong',
              });
            })
        }
      } else {
        vm.$notify({
          group: "status",
          type: "error",
          title: "OOPS!!!",
          text: 'Please fill all required fields',
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main_modal {
  position: fixed;
  width: 100%;
  height: calc(100% - 60px);
  background: rgba(0, 0, 0, 0.268);
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  padding: 20px 0;
  align-items: center;
  overflow-y: scroll;
  transition: .8s;
  z-index: 20;

  @media (max-height: 859px) {
    align-items: flex-start;
  }

  @media (max-width: 450px) {
    padding: 0;
  }

  &.activeSide {
    width: calc(100% - 230px);

    @media (max-width: 966px) {
      width: 100%;
    }

    .main_modal_crd {
      .modal_body {
        .modal_body_part {
          &.split_step {
            @media (max-width: 1162px) {
              grid-template-columns: 58% 40%;
            }

            @media (max-width: 768px) {
              grid-template-columns: 100%;
              row-gap: 20px;
            }
          }
        }
      }
    }
  }

  .main_modal_crd {
    width: 90%;
    background: white;
    min-height: 300px;
    height: fit-content;
    border-radius: 10px;
    position: relative;
    overflow: hidden;

    @media (max-width: 580px) {
      width: 95%;
    }

    @media (max-width: 450px) {
      width: 100%;
      border-radius: 0;
      height: calc(100vh - 60px);
    }

    .modal_top {
      display: flex;
      padding: 16px 23px;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #dfdfdf;
      position: sticky;
      top: 0;

      h1 {
        font-size: 17px;
        font-weight: 600;
      }

      span {
        cursor: pointer;
      }
    }

    .modal_body {
      height: 550px;
      overflow-y: auto;
      padding: 10px 23px 75px;

      @media (max-width: 580px) {
        padding-bottom: 100px;
      }

      @media (max-width: 450px) {
        padding-bottom: 75px;
        height: 88%;
      }

      .modal_body_part {
        &.upload_step {
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;

          .upload_cover {
            display: flex;
            width: 90px;
            height: 90px;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            background: #D9D9D9;
            margin-bottom: 20px;
          }

          h1 {
            font-weight: 600;
            margin-bottom: 5px;
          }

          p {
            opacity: .7;
            text-align: center;
            // margin-bottom: 20px;
          }

          .upload-trigger {
            width: 40%;
            margin-top: 20px;
          }
        }

        &.split_step {
          display: grid;
          grid-template-columns: 68% 30%;
          justify-content: space-between;

          @media (max-width: 1000px) {
            grid-template-columns: 58% 40%;
          }

          @media (max-width: 768px) {
            grid-template-columns: 100%;
            row-gap: 20px;
          }

          .split_part_data {
            h1.title {
              margin-bottom: 15px;
              font-size: 23px;
            }

            .b-field-txt {
              opacity: .6;

              &.mbottom {
                margin-bottom: 10px;
              }
            }

            .taginput.control {
              display: flex;
            }

            .upload-trigger {
              width: 200px;
            }

            .visibility-grp {
              .visibility-grp-title {
                font-weight: 700;
              }

              .visibility-grp-sub {
                opacity: .7;
              }

              .visibility-togglers {
                margin-top: 10px;
                display: flex;
                flex-direction: column;
                row-gap: 10px;
                padding-left: 40px;

                .visibility-togglers-each {
                  h1 {
                    display: flex;
                  }
                }
              }
            }
          }

          .split_part_view {
            .data_cover {
              height: 300px;
              border-radius: 10px;
              overflow: hidden;
              position: relative;
              margin-bottom: 13px;

              .b-skeleton {
                height: 100%;

                .b-skeleton-item {
                  height: 100%;
                }
              }

              img {
                height: 100%;
                width: 100%;
                object-fit: cover;
              }

              .media {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 50px;
                height: 50px;
                display: flex;
                justify-content: center;
                align-items: center;
                background: white;
                border-radius: 50%;
                cursor: pointer;
                box-shadow: 0 0 20px rgba(0, 0, 0, 0.344);

              }

              .media-visibility-status {
                position: absolute;
                bottom: 20px;
                right: 20px;
                padding: 6px 13px;
                font-size: 15px;
                border-radius: 3px;
                text-transform: capitalize;
              }
            }

            h1.name {
              font-weight: 600;
              font-size: 20px;
              margin-bottom: 13px;
            }

            p.descr {
              font-size: 16px;
              opacity: .7;
              margin-bottom: 15px;
            }

            .spaced-skeleton {
              margin-bottom: 15px;
            }

            .split_data_pt {
              display: flex;
              flex-direction: column;
              row-gap: 10px;

              .split_data_pt_crd {
                display: flex;
                font-size: 15px;

                .split_data_pt_crd_more {
                  margin-left: 5px;

                  .b-skeleton {
                    height: 100%;

                    .b-skeleton-item {
                      width: 200px;
                    }
                  }

                  span {
                    i {
                      display: inline-flex;
                      margin: 0 2px;
                    }

                    &:last-of-type {
                      i {
                        display: none;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .modal_footer {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 10px 23px;
      align-items: center;
      background: white;
      z-index: 10;
      border-top: 1px solid #dfdfdf;

      @media (max-width: 580px) {
        flex-direction: column;
        row-gap: 5px;
      }

      span {
        display: flex;
        align-items: center;
      }

      .actions {
        display: flex;
        align-items: center;
        column-gap: 20px;

        @media (max-width: 580px) {
          width: 100%;
          justify-content: space-between;
        }
      }
    }
  }
}
</style>